import React, { useEffect, useRef, useState, useMemo } from "react";
import Layout from "../layout/Layout";
import { api } from "../utils/Api";
import axios from "axios";
import {
	Button,
	Flex,
	Typography,
	Modal,
	Statistic,
	notification,
	DatePicker,
	Select,
	Tag,
	Tooltip,
	TimePicker,
	Table,
	Row,
	Col,
	Form,
	Input,
	Checkbox,
} from "antd";
import { CustomSpinner } from "../utils/CustomComponents";
import dayjs from "dayjs";
import {
	DollarOutlined,
	PhoneOutlined,
	RightSquareOutlined,
	DownloadOutlined,
	MailOutlined,
	SaveOutlined,
	PlusOutlined,
	SaveFilled,
	EditFilled,
} from "@ant-design/icons";
import PaymentJob2 from "./PaymentJob2";
import OpenInvoices from "../invoice/OpenInvoices";
import SendStatements from "./SendStatements";
import AddressJob from "../map/AddressJob";
import LoadJob from "../load/LoadJob";
import {
	delayedPouringElements,
	jobStatusOptions,
	jobStatusOptions2,
} from "../../constants/Job";
import JobCheckIn from "./JobCheckIn";
import JobToInvoiceModal from "../invoice/JobToInvoiceModal";
import { toThousands } from "../utils/Convert";
import { getAggregateCogsCost } from "../utils/CogCost";
const { Text, Title } = Typography;

const DailySellerDashboard = ({ history }) => {
	const [loading, setLoading] = useState(false);
	const [loadingTable, setLoadingTable] = useState(false);
	const [loadingSeller, setLoadingSeller] = useState(true);
	const [loadingPlant, setLoadingPlant] = useState(true);
	const [customerLoading, setCustomerLoading] = useState(true);
	const [loadingButtonPouring, setLoadingButtonPouring] = useState(false);
	const [loadingButtonLogistics, setLoadingButtonLogistics] = useState(false);
	const [loadingButtonComment, setLoadingButtonComment] = useState(false);
	const [regularJobs, setRegularJobs] = useState([]);
	const [scheduledJobs, setScheduledJobs] = useState([]);
	const [pouringJobs, setPouringJobs] = useState([]);
	const [pouredJobs, setPouredJobs] = useState([]);
	const [startDate, setStartDate] = useState(dayjs());
	const [optionsSellers, setOptionsSellers] = useState([]);
	const [customerList, setCustomerList] = useState([]);
	const [optionsPlant, setOptionsPlant] = useState([]);
	const [seller, setSeller] = useState("All");
	const [customer, setCustomer] = useState(undefined);
	const [plant, setPlant] = useState(
		localStorage.getItem("plant") || "61985b6a86825f39cc4aba38",
	);
	const [modalInvoiceOpen, setModalInvoiceOpen] = useState(false);
	const [modalOpenInvoicesOpen, setModalOpenInvoicesOpen] = useState(false);
	const [modalSendOpen, setModalSendOpen] = useState(false);
	const [modalOpenJobAddress, setModalOpenJobAddress] = useState(false);
	const [modalOpenAddLoad, setModalOpenAddLoad] = useState(false);
	const [modalOpenLogisticsComment, setModalOpenLogisticsComment] =
		useState(false);
	const [openCheckInModal, setOpenCheckInModal] = useState(false);
	const [showInvoiceModal, setShowInvoiceModal] = useState(false);
	const [showPouringModal, setShowPouringModal] = useState(false);
	const [showCommentsModal, setShowCommentsModal] = useState(false);
	const [apiNotification, contextHolder] = notification.useNotification();
	const jobId = useRef(null);
	const job = useRef(null);
	const jobNumber = useRef(null);
	const customerId = useRef(null);
	const shipAddress = useRef(null);
	const latitude = useRef(null);
	const longitude = useRef(null);
	const plantId = useRef(null);
	const typeSend = useRef(null);
	const jobType = useRef(null);
	const logisticConfirmation = useRef(null);
	const cannotChangeStatus = useRef(false);
	const checkInValuesForm = useRef(null);
	const comments = useRef(null);
	const [formLogistics] = Form.useForm();
	const [formPouring] = Form.useForm();
	const [formComment] = Form.useForm();
	const [checkInLatitude, setCheckInLatitude] = useState(undefined);
	const [checkInLongitude, setCheckInLongitude] = useState(undefined);
	const [refresh, setRefresh] = useState(false);
	const [scheduledTargetYD3, setScheduledTargetYD3] = useState(0);
	const [pouringTargetYD3, setPouringTargetYD3] = useState(0);
	const [pouringLoadYD3, setPouringLoadYD3] = useState(0);
	const [pouredLoadYD3, setPouredLoadYD3] = useState(0);
	const [readyTargetYD3, setReadyTargetYD3] = useState(0);
	const [totalLoadYards, setTotalLoadYards] = useState(0);
	const [totalTargetYards, setTotalTargetYards] = useState(0);
	const [totalBalanceYards, setTotalBalanceYards] = useState(0);
	const [totalWaitYards, setTotalWaitYards] = useState(0);
	const [totalGlobalYards, setTotalGlobalYards] = useState(0);

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	/**
	 ** Options header (columns)
	 */
	const columns = [
		{
			title: "Confirm",
			dataIndex: "confirm",
			key: "confirm",
			width: 150,
			render: (value, record) => {
				return (
					<Flex gap={16}>
						<Checkbox
							checked={value}
							disabled={
								!(
									localStorage.getItem("email") === "eliud@gmail.com" ||
									localStorage.getItem("email") === "ec@57concrete.com" ||
									localStorage.getItem("email") === "mv@57concrete.com" ||
									localStorage.getItem("email") === "al@57concrete.com" ||
									localStorage.getItem("email") === "vo@57concrete.com" ||
									localStorage.getItem("email") === "mb@57concrete.com" ||
									localStorage.getItem("email") === "jp@57concrete.com" ||
									localStorage.getItem("email") === "bp@57concrete.com" ||
									localStorage.getItem("email") === "bpa@57concrete.com" ||
									localStorage.getItem("email") === "wc@57concrete.com" ||
									localStorage.getItem("email") === "dm@57concrete.com" ||
									localStorage.getItem("email") === "bm@57concrete.com" ||
									localStorage.getItem("email") === "rl@57concrete.com" ||
									localStorage.getItem("email") === "mrg@57concrete.com" ||
									localStorage.getItem("email") === "pc@57concrete.com" ||
									localStorage.getItem("email") === "gg@57xgroup.com" ||
									localStorage.getItem("email") === "scale@filegonia.com" ||
									localStorage.getItem("email") === "jc@57concrete.com" ||
									localStorage.getItem("email") === "reyesss22@icloud.com" ||
									localStorage.getItem("email") === "office@57logistics.com"
								) || localStorage.getItem("email") === "jh@57concrete.com"
							}
							onChange={(e) => {
								setLoadingTable(true);
								if (record.jobType === "Scheduled") {
									const newJobs = [...scheduledJobs];
									const index = newJobs.findIndex((i) => i.id === record.id);
									if (index !== -1) {
										newJobs[index] = {
											...newJobs[index],
											confirm: e.target.checked,
										};
										setScheduledJobs(newJobs);
									}
								} else if (record.jobType === "Pouring") {
									const newJobs = [...pouringJobs];
									const index = newJobs.findIndex((i) => i.id === record.id);
									if (index !== -1) {
										newJobs[index] = {
											...newJobs[index],
											confirm: e.target.checked,
										};
										setPouringJobs(newJobs);
									}
								} else if (record.jobType === "Poured") {
									const newJobs = [...pouredJobs];
									const index = newJobs.findIndex((i) => i.id === record.id);
									if (index !== -1) {
										newJobs[index] = {
											...newJobs[index],
											confirm: e.target.checked,
										};
										setPouredJobs(newJobs);
									}
								} else if (record.jobType === "Regular") {
									const newJobs = [...regularJobs];
									const index = newJobs.findIndex((i) => i.id === record.id);
									if (index !== -1) {
										newJobs[index] = {
											...newJobs[index],
											confirm: e.target.checked,
										};
										setRegularJobs(newJobs);
									}
								}
								setLoadingTable(false);
							}}
						/>
						{record.creditHold === true && <Text strong>Credit on Hold</Text>}
					</Flex>
				);
			},
		},
		{
			title: "Job ID",
			dataIndex: "jobId",
			key: "jobId",
			width: 100,
			render: (value, record) => {
				return (
					<Text
						strong
						underline
						style={{ cursor: "pointer" }}
						onClick={() => history.push(`/job/${record.id}`)}
					>
						{value}
					</Text>
				);
			},
			sorter: (a, b) => {
				const aVal = isNaN(a.jobId) ? a.jobId : Number(a.jobId);
				const bVal = isNaN(b.jobId) ? b.jobId : Number(b.jobId);
				return aVal > bVal ? 1 : aVal < bVal ? -1 : 0;
			},
			sortDirections: ["ascend", "descend"],
		},
		{
			title: "Customer",
			dataIndex: "customer",
			key: "customer",
			width: 200,
			render: (value, record) => {
				return (
					<Text
						underline
						onClick={() => {
							customerId.current = record.customerId;
							setModalOpenInvoicesOpen(true);
						}}
						style={{ cursor: "pointer" }}
					>
						{value}
					</Text>
				);
			},
		},
		{
			title: "Customer Profile Status",
			dataIndex: "customerProfileStatus",
			key: "customerProfileStatus",
			width: 200,
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Seller",
			dataIndex: "seller",
			key: "seller",
			width: 200,
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Project Name",
			dataIndex: "projectName",
			key: "projectName",
			width: 200,
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Time",
			dataIndex: "time",
			key: "time",
			width: 150,
			render: (value, record) => {
				return (
					<TimePicker
						value={value}
						format={"h:mm A"}
						use12Hours
						showNow={false}
						size="large"
						allowClear={false}
						onOk={(v) => {
							setLoadingTable(true);
							if (record.jobType === "Scheduled") {
								const newJobs = [...scheduledJobs];
								const index = newJobs.findIndex((i) => i.id === record.id);
								if (index !== -1) {
									newJobs[index] = { ...newJobs[index], time: v };
									setScheduledJobs(newJobs);
								}
							} else if (record.jobType === "Pouring") {
								const newJobs = [...pouringJobs];
								const index = newJobs.findIndex((i) => i.id === record.id);
								if (index !== -1) {
									newJobs[index] = { ...newJobs[index], time: v };
									setPouringJobs(newJobs);
								}
							} else if (record.jobType === "Poured") {
								const newJobs = [...pouredJobs];
								const index = newJobs.findIndex((i) => i.id === record.id);
								if (index !== -1) {
									newJobs[index] = { ...newJobs[index], time: v };
									setPouredJobs(newJobs);
								}
							} else if (record.jobType === "Regular") {
								const newJobs = [...regularJobs];
								const index = newJobs.findIndex((i) => i.id === record.id);
								if (index !== -1) {
									newJobs[index] = { ...newJobs[index], time: v };
									setRegularJobs(newJobs);
								}
							}
							setLoadingTable(false);
						}}
					/>
				);
			},
		},
		{
			title: "Job Address",
			dataIndex: "address",
			key: "address",
			width: 200,
			render: (_, record) => {
				return (
					<Text
						style={{ cursor: "pointer" }}
						underline
						onClick={() => {
							latitude.current = record.latitude;
							longitude.current = record.longitude;
							shipAddress.current = record.shipAddress;
							plantId.current = record.plantId;
							setModalOpenJobAddress(true);
						}}
					>{`${record.customerShipAddress} - ${record.shipAddress}`}</Text>
				);
			},
		},
		{
			title: "Load YD3",
			dataIndex: "loadYD3",
			key: "loadYD3",
			width: 120,
			render: (value, record) => {
				return (
					<Flex gap={16} justify="center">
						{(record.jobStatus === "Inactive" ||
							record.jobStatus === "Confirm" ||
							record.jobStatus === "Active" ||
							record.jobStatus === "ok") && (
							<Button
								type="primary"
								icon={<PlusOutlined twoToneColor={"white"} />}
								onClick={() => {
									job.current = record.job;
									jobId.current = record.id;
									jobType.current = record.jobType;
									jobNumber.current = record.jobId;
									logisticConfirmation.current = record.logisticConfirmation;
									setModalOpenAddLoad(true);
								}}
							/>
						)}
						<Text>{value}</Text>
					</Flex>
				);
			},
		},
		{
			title: "Target YD3",
			dataIndex: "targetYD3",
			key: "targetYD3",
			width: 120,
			render: (value, record) => {
				return <Text>{`${value} + ${record.balance || 0}`}</Text>;
			},
		},
		{
			title: "Mix Design",
			dataIndex: "mixDesign",
			key: "mixDesign",
			width: 200,
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Slump",
			dataIndex: "slump",
			key: "slump",
			width: 100,
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Fiber YD3",
			dataIndex: "fiber",
			key: "fiber",
			width: 100,
			render: (value, record) => {
				return (
					<Flex gap={16}>
						<Checkbox checked={value} />
						<Text>{record.fiberQuantity}</Text>
					</Flex>
				);
			},
		},
		{
			title: "Sales Price",
			dataIndex: "salesPrice",
			key: "salesPrice",
			width: 100,
			render: (value) => {
				return (
					<Statistic
						value={value}
						precision={2}
						valueStyle={{
							fontSize: 14,
						}}
						prefix="$"
					/>
				);
			},
		},
		{
			title: "Minimum Price",
			dataIndex: "minPrice",
			key: "minPrice",
			width: 100,
			render: (value) => {
				return (
					<Statistic
						value={value}
						precision={2}
						valueStyle={{
							fontSize: 14,
						}}
						prefix="$"
					/>
				);
			},
		},
		{
			title: "Order",
			dataIndex: "totalAmount",
			key: "totalAmount",
			render: (value) => {
				return (
					<Statistic
						value={value}
						precision={2}
						valueStyle={{
							fontSize: 14,
						}}
						prefix="$"
					/>
				);
			},
		},
		{
			title: "Open Balance",
			dataIndex: "openBalance",
			key: "openBalance",
			render: (value) => {
				return (
					<Statistic
						value={value}
						precision={2}
						valueStyle={{
							fontSize: 14,
						}}
						prefix="$"
					/>
				);
			},
		},
		{
			title: "Pastdue Balance",
			dataIndex: "overdueBalance",
			key: "overdueBalance",
			render: (value) => {
				return (
					<Statistic
						value={value}
						precision={2}
						valueStyle={{
							fontSize: 14,
						}}
						prefix="$"
					/>
				);
			},
		},
		{
			title: "Authorized Credit Limit",
			dataIndex: "authorizedCreditLimit",
			key: "authorizedCreditLimit",
			render: (value) => {
				return (
					<Statistic
						value={value}
						precision={2}
						valueStyle={{
							fontSize: 14,
						}}
						prefix="$"
					/>
				);
			},
		},
		{
			title: "Action",
			dataIndex: "action",
			width: 200,
			render: (_, record) => {
				return (
					<Flex gap={16}>
						{record.jobStatus === "Operations done (AR)" && (
							<Tooltip title="Payment">
								<Button
									type="primary"
									style={{
										backgroundColor: "#edbc0bff",
										color: "black",
										borderColor: "#edbc0bff",
									}}
									icon={<DollarOutlined twoToneColor={"black"} />}
									onClick={() => {
										jobId.current = record.id;
										setModalInvoiceOpen(true);
									}}
								/>
							</Tooltip>
						)}
						{record.jobStatus === "Operations done (AR)" && (
							<Tooltip title="Statement">
								<Button
									type="primary"
									style={{
										backgroundColor: "#ffffff",
										color: "black",
										borderColor: "#ffffff",
									}}
									icon={<RightSquareOutlined twoToneColor={"black"} />}
									onClick={() => generateStatement(record.customerId)}
								/>
							</Tooltip>
						)}
						{record.jobStatus === "Operations done (AR)" && (
							<Tooltip title="Statement Payment">
								<Button
									type="primary"
									style={{
										backgroundColor: "#44742e",
										color: "white",
										borderColor: "#44742e",
									}}
									icon={<DownloadOutlined twoToneColor={"white"} />}
									onClick={() => generateStatementPayment(record.customerId)}
								/>
							</Tooltip>
						)}
						{record.jobStatus === "Operations done (AR)" && (
							<Tooltip title="Send Statements Email">
								<Button
									type="primary"
									icon={<MailOutlined twoToneColor={"white"} />}
									onClick={() => {
										customerId.current = record.customerId;
										typeSend.current = "email";
										setModalSendOpen(true);
									}}
								/>
							</Tooltip>
						)}
						{record.jobStatus === "Operations done (AR)" && (
							<Tooltip title="Send Statements Phone">
								<Button
									type="primary"
									icon={<PhoneOutlined twoToneColor={"white"} />}
									onClick={() => {
										customerId.current = record.customerId;
										typeSend.current = "sms";
										setModalSendOpen(true);
									}}
								/>
							</Tooltip>
						)}
					</Flex>
				);
			},
		},
		{
			title: "Pour/Type",
			dataIndex: "pourType",
			key: "pourType",
			width: 100,
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Job Status",
			dataIndex: "jobStatus",
			key: "jobStatus",
			width: 150,
			onCell: (record) => {
				let bg = "";

				if (record.customerCreditHold === true) {
					bg = "#ffffff";
				} else {
					switch (record.jobStatus) {
						case "Trouble":
							bg = "#7a7977";
							break;
						case "Inactive":
							bg = "#ffffff";
							break;
						case "ok":
							bg = "#7ad765";
							break;
						case "Ready to Load":
							bg = "#208928";
							break;
						case "Ready to be scheduled":
							bg = "#208928";
							break;
						case "Active":
							bg = "#fff569";
							break;
						case "Date moved":
							bg = "#d9a809";
							break;
						case "Operations done (AR)":
							bg = "#fce0a2";
							break;
						case "Company cancellation":
							bg = "#e087fa";
							break;
						case "Customer cancellation":
							bg = "#ad87fa";
							break;
						case "Quote":
							bg = "#c3c2c0";
							break;
						case "Confirm":
							bg = "#31b9f7";
							break;
						case "Scheduled":
							bg = "#e3495d";
							break;
						default:
							bg = "#fff569";
							break;
					}
				}

				return {
					style: {
						backgroundColor: bg,
					},
				};
			},
			render: (value, record) => {
				return (
					<Flex vertical gap={16}>
						{record.customerCreditHold === true
							? "Inactive"
							: record.jobStatus2
								? record.jobStatus2
								: record.jobStatus}

						{!record.restrict &&
							record.confirm &&
							record.customerCreditHold === false && (
								<Select
									style={{
										width: "100%",
									}}
									size="large"
									value={value}
									placeholder="Please select job status"
									options={jobStatusOptions2}
									disabled={
										localStorage.getItem("email") === "dm@57concrete.com" ||
										localStorage.getItem("email") === "bm@57concrete.com" ||
										localStorage.getItem("email") === "rl@57concrete.com" ||
										localStorage.getItem("email") === "rs@57concrete.com" ||
										localStorage.getItem("email") === "jp@57concrete.com" ||
										localStorage.getItem("email") === "ji@57concrete.com" ||
										localStorage.getItem("email") === "vm@57concrete.com" ||
										localStorage.getItem("email") === "ec@57concrete.com" ||
										localStorage.getItem("email") === "pc@57concrete.com" ||
										localStorage.getItem("email") === "jc@57concrete.com" ||
										localStorage.getItem("email") === "gg@57xgroup.com" ||
										localStorage.getItem("email") === "eliud@gmail.com"
											? false
											: true
									}
									optionFilterProp="children"
									filterOption={filterOption}
									showSearch
									labelInValue
									onChange={async (selectedOption) => {
										if (selectedOption) {
											if (
												selectedOption.value === "Operations done (AR)" &&
												record.approvedPrice === false
											) {
												setLoadingTable(true);
												let status = record.jobStatus;
												let jobStatus2 = record.jobStatus;
												if (status === "ok") {
													jobStatus2 = "Poured";
												} else if (status === "Active") {
													jobStatus2 = "Pouring";
												} else if (status === "Confirm") {
													jobStatus2 = "A/R Confirmed";
												} else if (status === "Ready to Load") {
													jobStatus2 = "Ready to be scheduled";
												}
												if (record.jobType === "Scheduled") {
													const newJobs = [...scheduledJobs];
													const index = newJobs.findIndex(
														(i) => i.id === record.id,
													);
													if (index !== -1) {
														newJobs[index] = {
															...newJobs[index],
															jobStatus: record.jobStatusPrev,
															jobStatus2,
														};
														setScheduledJobs(newJobs);
													}
												} else if (record.jobType === "Pouring") {
													const newJobs = [...pouringJobs];
													const index = newJobs.findIndex(
														(i) => i.id === record.id,
													);
													if (index !== -1) {
														newJobs[index] = {
															...newJobs[index],
															jobStatus: record.jobStatusPrev,
															jobStatus2,
														};
														setPouringJobs(newJobs);
													}
												} else if (record.jobType === "Poured") {
													const newJobs = [...pouredJobs];
													const index = newJobs.findIndex(
														(i) => i.id === record.id,
													);
													if (index !== -1) {
														newJobs[index] = {
															...newJobs[index],
															jobStatus: record.jobStatusPrev,
															jobStatus2,
														};
														setPouredJobs(newJobs);
													}
												} else if (record.jobType === "Regular") {
													const newJobs = [...regularJobs];
													const index = newJobs.findIndex(
														(i) => i.id === record.id,
													);
													if (index !== -1) {
														newJobs[index] = {
															...newJobs[index],
															jobStatus: record.jobStatusPrev,
															jobStatus2,
														};
														setRegularJobs(newJobs);
													}
												}
												setLoadingTable(false);
												openNotification(
													"info",
													"Info",
													"Approved Price must be checked",
												);
												return;
											}

											setLoadingTable(true);
											if (record.jobType === "Scheduled") {
												const newJobs = [...scheduledJobs];
												const index = newJobs.findIndex(
													(i) => i.id === record.id,
												);
												if (index !== -1) {
													const checkInValues = {
														...newJobs[index].checkInValues,
														jobStatus: selectedOption.value,
													};

													newJobs[index] = {
														...newJobs[index],
														jobStatus: selectedOption.value,
														jobStatus2: selectedOption.label,
														jobStatusSellerChange: true,
														checkInValues: checkInValues,
														confirm: true,
														readyToBeScheduledDate:
															selectedOption.value === "Ready to Load"
																? dayjs()
																: record.readyToBeScheduledDate,
														readyToBeScheduledDateFormat:
															selectedOption.value === "Ready to Load"
																? dayjs().format("MM/DD/YYYY hh:mm a")
																: record.readyToBeScheduledDateFormat,
													};
													setScheduledJobs(newJobs);

													checkInValuesForm.current = checkInValues;
													jobType.current = record.jobType;
													jobId.current = record.id;
													if (
														selectedOption.value === "Ready to Load" &&
														localStorage.getItem("email") !==
															"eliud@gmail.com" &&
														!record.checkInValues.measurement
													) {
														handleCheckInOpen(
															record.latitude,
															record.longitude,
															record.checkInLatitude,
															record.checkInLongitude,
															record.checkInValues.measurement,
															record.isOver30,
														);
													}

													if (selectedOption.value === "Operations done (AR)") {
														const exist = await getInvoiceExistance(record.id);
														if (!exist) {
															jobId.current = record.id;
															handleInvoice();
														}
													}

													if (selectedOption.value === "Active") {
														let scheduledDate = dayjs(record.scheduledDate);
														let nowDate = dayjs();
														let diff = record.destinationTime
															? parseInt(record.destinationTime.split(" ")[0])
															: record.destinationMinutes;
														let scheduledDateMin = scheduledDate.subtract(
															diff,
															"minute",
														);
														if (
															nowDate.isAfter(scheduledDateMin) ||
															nowDate.isSame(scheduledDateMin)
														) {
															jobId.current = record.id;
															handlePouringModal();
														}
													}
												}
											} else if (record.jobType === "Pouring") {
												const newJobs = [...pouringJobs];
												const index = newJobs.findIndex(
													(i) => i.id === record.id,
												);
												if (index !== -1) {
													const checkInValues = {
														...newJobs[index].checkInValues,
														jobStatus: selectedOption.value,
													};
													newJobs[index] = {
														...newJobs[index],
														jobStatus: selectedOption.value,
														jobStatus2: selectedOption.label,
														jobStatusSellerChange: true,
														checkInValues: checkInValues,
														confirm: true,
														readyToBeScheduledDate:
															selectedOption.value === "Ready to Load"
																? dayjs()
																: record.readyToBeScheduledDate,
														readyToBeScheduledDateFormat:
															selectedOption.value === "Ready to Load"
																? dayjs().format("MM/DD/YYYY hh:mm a")
																: record.readyToBeScheduledDateFormat,
													};
													setPouringJobs(newJobs);

													checkInValuesForm.current = checkInValues;
													jobType.current = record.jobType;
													jobId.current = record.id;
													if (
														selectedOption.value === "Ready to Load" &&
														localStorage.getItem("email") !==
															"eliud@gmail.com" &&
														!record.checkInValues.measurement
													) {
														handleCheckInOpen(
															record.latitude,
															record.longitude,
															record.checkInLatitude,
															record.checkInLongitude,
															record.checkInValues.measurement,
															record.isOver30,
														);
													}

													if (selectedOption.value === "Operations done (AR)") {
														const exist = await getInvoiceExistance(record.id);
														if (!exist) {
															jobId.current = record.id;
															handleInvoice();
														}
													}

													if (selectedOption.value === "Active") {
														let scheduledDate = dayjs(record.scheduledDate);
														let nowDate = dayjs();
														let diff = record.destinationTime
															? parseInt(record.destinationTime.split(" ")[0])
															: record.destinationMinutes;
														let scheduledDateMin = scheduledDate.subtract(
															diff,
															"minute",
														);
														if (
															nowDate.isAfter(scheduledDateMin) ||
															nowDate.isSame(scheduledDateMin)
														) {
															jobId.current = record.id;
															handlePouringModal();
														}
													}
												}
											} else if (record.jobType === "Poured") {
												const newJobs = [...pouredJobs];
												const index = newJobs.findIndex(
													(i) => i.id === record.id,
												);
												if (index !== -1) {
													const checkInValues = {
														...newJobs[index].checkInValues,
														jobStatus: selectedOption.value,
													};
													newJobs[index] = {
														...newJobs[index],
														jobStatus: selectedOption.value,
														jobStatus2: selectedOption.label,
														jobStatusSellerChange: true,
														checkInValues: checkInValues,
														confirm: true,
														readyToBeScheduledDate:
															selectedOption.value === "Ready to Load"
																? dayjs()
																: record.readyToBeScheduledDate,
														readyToBeScheduledDateFormat:
															selectedOption.value === "Ready to Load"
																? dayjs().format("MM/DD/YYYY hh:mm a")
																: record.readyToBeScheduledDateFormat,
													};
													setPouredJobs(newJobs);

													checkInValuesForm.current = checkInValues;
													jobType.current = record.jobType;
													jobId.current = record.id;
													if (
														selectedOption.value === "Ready to Load" &&
														localStorage.getItem("email") !==
															"eliud@gmail.com" &&
														!record.checkInValues.measurement
													) {
														handleCheckInOpen(
															record.latitude,
															record.longitude,
															record.checkInLatitude,
															record.checkInLongitude,
															record.checkInValues.measurement,
															record.isOver30,
														);
													}

													if (selectedOption.value === "Operations done (AR)") {
														const exist = await getInvoiceExistance(record.id);
														if (!exist) {
															jobId.current = record.id;
															handleInvoice();
														}
													}

													if (selectedOption.value === "Active") {
														let scheduledDate = dayjs(record.scheduledDate);
														let nowDate = dayjs();
														let diff = record.destinationTime
															? parseInt(record.destinationTime.split(" ")[0])
															: record.destinationMinutes;
														let scheduledDateMin = scheduledDate.subtract(
															diff,
															"minute",
														);
														if (
															nowDate.isAfter(scheduledDateMin) ||
															nowDate.isSame(scheduledDateMin)
														) {
															jobId.current = record.id;
															handlePouringModal();
														}
													}
												}
											} else if (record.jobType === "Regular") {
												const newJobs = [...regularJobs];
												const index = newJobs.findIndex(
													(i) => i.id === record.id,
												);
												if (index !== -1) {
													const checkInValues = {
														...newJobs[index].checkInValues,
														jobStatus: selectedOption.value,
													};
													newJobs[index] = {
														...newJobs[index],
														jobStatus: selectedOption.value,
														jobStatus2: selectedOption.label,
														jobStatusSellerChange: true,
														checkInValues: checkInValues,
														confirm: true,
														readyToBeScheduledDate:
															selectedOption.value === "Ready to Load"
																? dayjs()
																: record.readyToBeScheduledDate,
														readyToBeScheduledDateFormat:
															selectedOption.value === "Ready to Load"
																? dayjs().format("MM/DD/YYYY hh:mm a")
																: record.readyToBeScheduledDateFormat,
													};
													setRegularJobs(newJobs);

													checkInValuesForm.current = checkInValues;
													jobType.current = record.jobType;
													jobId.current = record.id;
													if (
														selectedOption.value === "Ready to Load" &&
														localStorage.getItem("email") !==
															"eliud@gmail.com" &&
														!record.checkInValues.measurement
													) {
														handleCheckInOpen(
															record.latitude,
															record.longitude,
															record.checkInLatitude,
															record.checkInLongitude,
															record.checkInValues.measurement,
															record.isOver30,
														);
													}

													if (selectedOption.value === "Operations done (AR)") {
														const exist = await getInvoiceExistance(record.id);
														if (!exist) {
															jobId.current = record.id;
															handleInvoice();
														}
													}

													if (selectedOption.value === "Active") {
														let scheduledDate = dayjs(record.scheduledDate);
														let nowDate = dayjs();
														let diff = record.destinationTime
															? parseInt(record.destinationTime.split(" ")[0])
															: record.destinationMinutes;
														let scheduledDateMin = scheduledDate.subtract(
															diff,
															"minute",
														);
														if (
															nowDate.isAfter(scheduledDateMin) ||
															nowDate.isSame(scheduledDateMin)
														) {
															jobId.current = record.id;
															handlePouringModal();
														}
													}
												}
											}

											setLoadingTable(false);
										}
									}}
								/>
							)}

						{!(
							!record.restrict &&
							record.confirm &&
							record.customerCreditHold === false
						) &&
							localStorage.getItem("role") === "Seller" && (
								<Select
									style={{
										width: "100%",
									}}
									size="large"
									value={value}
									placeholder="Please select job status"
									options={jobStatusOptions}
									disabled={
										localStorage.getItem("role") === "Seller" &&
										localStorage.getItem("email") !== "rl@57concrete.com" &&
										localStorage.getItem("email") !== "bm@57concrete.com"
									}
									optionFilterProp="children"
									filterOption={filterOption}
									showSearch
									labelInValue
									onChange={(selectedOption) => {
										if (selectedOption) {
											if (
												selectedOption.value === "Operations done (AR)" &&
												record.approvedPrice === false
											) {
												setLoadingTable(true);
												let status = record.jobStatus;
												let jobStatus2 = record.jobStatus;
												if (status === "ok") {
													jobStatus2 = "Poured";
												} else if (status === "Active") {
													jobStatus2 = "Pouring";
												} else if (status === "Confirm") {
													jobStatus2 = "A/R Confirmed";
												} else if (status === "Ready to Load") {
													jobStatus2 = "Ready to be scheduled";
												}
												if (record.jobType === "Scheduled") {
													const newJobs = [...scheduledJobs];
													const index = newJobs.findIndex(
														(i) => i.id === record.id,
													);
													if (index !== -1) {
														newJobs[index] = {
															...newJobs[index],
															jobStatus: record.jobStatusPrev,
															jobStatus2,
														};
														setScheduledJobs(newJobs);
													}
												} else if (record.jobType === "Pouring") {
													const newJobs = [...pouringJobs];
													const index = newJobs.findIndex(
														(i) => i.id === record.id,
													);
													if (index !== -1) {
														newJobs[index] = {
															...newJobs[index],
															jobStatus: record.jobStatusPrev,
															jobStatus2,
														};
														setPouringJobs(newJobs);
													}
												} else if (record.jobType === "Poured") {
													const newJobs = [...pouredJobs];
													const index = newJobs.findIndex(
														(i) => i.id === record.id,
													);
													if (index !== -1) {
														newJobs[index] = {
															...newJobs[index],
															jobStatus: record.jobStatusPrev,
															jobStatus2,
														};
														setPouredJobs(newJobs);
													}
												} else if (record.jobType === "Regular") {
													const newJobs = [...regularJobs];
													const index = newJobs.findIndex(
														(i) => i.id === record.id,
													);
													if (index !== -1) {
														newJobs[index] = {
															...newJobs[index],
															jobStatus: record.jobStatusPrev,
															jobStatus2,
														};
														setRegularJobs(newJobs);
													}
												}
												setLoadingTable(false);
												openNotification(
													"info",
													"Info",
													"Approved Price must be checked",
												);
												return;
											}

											setLoadingTable(true);
											if (record.jobType === "Scheduled") {
												const newJobs = [...scheduledJobs];
												const index = newJobs.findIndex(
													(i) => i.id === record.id,
												);
												if (index !== -1) {
													const checkInValues = {
														...newJobs[index].checkInValues,
														jobStatus: selectedOption.value,
													};
													newJobs[index] = {
														...newJobs[index],
														jobStatus: selectedOption.value,
														jobStatus2: selectedOption.label,
														jobStatusSellerChange: true,
														checkInValues: checkInValues,
													};
													setScheduledJobs(newJobs);
												}
											} else if (record.jobType === "Pouring") {
												const newJobs = [...pouringJobs];
												const index = newJobs.findIndex(
													(i) => i.id === record.id,
												);
												if (index !== -1) {
													const checkInValues = {
														...newJobs[index].checkInValues,
														jobStatus: selectedOption.value,
													};
													newJobs[index] = {
														...newJobs[index],
														jobStatus: selectedOption.value,
														jobStatus2: selectedOption.label,
														jobStatusSellerChange: true,
														checkInValues: checkInValues,
													};
													setPouringJobs(newJobs);
												}
											} else if (record.jobType === "Poured") {
												const newJobs = [...pouredJobs];
												const index = newJobs.findIndex(
													(i) => i.id === record.id,
												);
												if (index !== -1) {
													const checkInValues = {
														...newJobs[index].checkInValues,
														jobStatus: selectedOption.value,
													};
													newJobs[index] = {
														...newJobs[index],
														jobStatus: selectedOption.value,
														jobStatus2: selectedOption.label,
														jobStatusSellerChange: true,
														checkInValues: checkInValues,
													};
													setPouredJobs(newJobs);
												}
											} else if (record.jobType === "Regular") {
												const newJobs = [...regularJobs];
												const index = newJobs.findIndex(
													(i) => i.id === record.id,
												);
												if (index !== -1) {
													const checkInValues = {
														...newJobs[index].checkInValues,
														jobStatus: selectedOption.value,
													};
													newJobs[index] = {
														...newJobs[index],
														jobStatus: selectedOption.value,
														jobStatus2: selectedOption.label,
														jobStatusSellerChange: true,
														checkInValues: checkInValues,
													};
													setRegularJobs(newJobs);
												}
											}
											setLoadingTable(false);
										}
									}}
								/>
							)}
					</Flex>
				);
			},
		},
		{
			title: "Scheduled Date",
			dataIndex: "readyToBeScheduledDateFormat",
			key: "readyToBeScheduledDateFormat",
			width: 150,
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		localStorage.getItem("jobHold") === "true" && {
			title: "Hold",
			dataIndex: "creditHold",
			key: "creditHold",
			width: 100,
			render: (value, record) => {
				return (
					<Flex vertical gap={16}>
						<Checkbox
							checked={value}
							disabled={
								localStorage.getItem("email") === "jh@57concrete.com" ||
								localStorage.getItem("email") === "jvb@57concrete.com"
							}
							onChange={(e) => {
								setLoadingTable(true);
								if (record.jobType === "Scheduled") {
									const newJobs = [...scheduledJobs];
									const index = newJobs.findIndex((i) => i.id === record.id);
									if (index !== -1) {
										newJobs[index] = {
											...newJobs[index],
											creditHold: e.target.checked,
											confirm: !newJobs[index].confirm,
											jobStatus: "Confirm",
										};
										setScheduledJobs(newJobs);
									}
								} else if (record.jobType === "Pouring") {
									const newJobs = [...pouringJobs];
									const index = newJobs.findIndex((i) => i.id === record.id);
									if (index !== -1) {
										newJobs[index] = {
											...newJobs[index],
											creditHold: e.target.checked,
											confirm: !newJobs[index].confirm,
											jobStatus: "Confirm",
										};
										setPouringJobs(newJobs);
									}
								} else if (record.jobType === "Poured") {
									const newJobs = [...pouredJobs];
									const index = newJobs.findIndex((i) => i.id === record.id);
									if (index !== -1) {
										newJobs[index] = {
											...newJobs[index],
											creditHold: e.target.checked,
											confirm: !newJobs[index].confirm,
											jobStatus: "Confirm",
										};
										setPouredJobs(newJobs);
									}
								} else if (record.jobType === "Regular") {
									const newJobs = [...regularJobs];
									const index = newJobs.findIndex((i) => i.id === record.id);
									if (index !== -1) {
										newJobs[index] = {
											...newJobs[index],
											creditHold: e.target.checked,
											confirm: !newJobs[index].confirm,
											jobStatus: "Confirm",
										};
										setRegularJobs(newJobs);
									}
								}
								setLoadingTable(false);
							}}
						/>
						{value && <Text strong>Job Hold</Text>}
					</Flex>
				);
			},
		},
		{
			title: "Check In",
			dataIndex: "measurement",
			key: "measurement",
			width: 100,
			render: (value) => {
				return <Checkbox checked={value} />;
			},
		},
		{
			title: "Ice Surcharge",
			dataIndex: "iceSurcharge",
			key: "iceSurcharge",
			width: 100,
			render: (value) => {
				return <Checkbox checked={value} />;
			},
		},
		{
			title: "Light Surcharge",
			dataIndex: "lightSurcharge",
			key: "lightSurcharge",
			width: 100,
			render: (value) => {
				return <Checkbox checked={value} />;
			},
		},
		{
			title: "Pour",
			dataIndex: "pour",
			key: "pour",
			width: 100,
			render: (value) => {
				return <Checkbox checked={value} />;
			},
		},
		{
			title: "Etickets",
			dataIndex: "etickets",
			key: "etickets",
			width: 100,
			render: (_, record) => {
				return (
					<Button
						type="primary"
						size="large"
						onClick={() => {
							history.push("/eticketsjob/" + record.id);
						}}
						disabled={
							!(
								record.jobStatus === "ok" ||
								record.jobStatus === "Active" ||
								record.jobStatus === "Confirm" ||
								record.jobStatus === "Operations done (AR)"
							)
						}
					>
						Etickets
					</Button>
				);
			},
		},
		{
			title: "Comments",
			dataIndex: "comments",
			key: "comments",
			width: 150,
			render: (value, record) => {
				return (
					<Flex gap={16} vertical>
						<Text>{value}</Text>
						<Button
							icon={<EditFilled />}
							onClick={() => {
								jobId.current = record.id;
								jobNumber.current = record.jobId;
								jobType.current = record.jobType;
								comments.current = record.comments;
								handleEditCommentOpen();
							}}
						/>
					</Flex>
				);
			},
		},
		{
			title: "Franchise",
			dataIndex: "franchise",
			key: "franchise",
			render: (value) => {
				return (
					<Tag
						color={
							value === "57Concrete"
								? "blue"
								: value === "Castle"
									? "green"
									: "cyan"
						}
					>
						{value}
					</Tag>
				);
			},
		},
		// {
		// 	title: "Project Name / Address",
		// 	dataIndex: "projectAddress",
		// 	key: "projectAddress",
		// 	render: (value) => {
		// 		return <Text>{value}</Text>;
		// 	},
		// 	sorter: (a, b) => a.projectAddress.localeCompare(b.projectAddress),
		// 	sortDirections: ["ascend", "descend"],
		// },
		{
			title: "Save Changes",
			dataIndex: "edit",
			width: 200,
			render: (_, record) => {
				return (
					<Flex gap={16}>
						{(localStorage.getItem("email") === "mv@57concrete.com" ||
							localStorage.getItem("email") === "al@57concrete.com" ||
							localStorage.getItem("email") === "ec@57concrete.com" ||
							localStorage.getItem("email") === "eliud@gmail.com" ||
							localStorage.getItem("email") === "pc@57concrete.com" ||
							localStorage.getItem("email") === "gg@57xgroup.com" ||
							localStorage.getItem("email") === "scale@filegonia.com" ||
							localStorage.getItem("email") === "jc@57concrete.com" ||
							localStorage.getItem("email") === "reyesss22@icloud.com" ||
							localStorage.getItem("email") === "office@57logistics.com" ||
							record.confirm ||
							record.jobStatusSellerChange) && (
							<Tooltip title="Save">
								<Button
									type="primary"
									icon={<SaveOutlined twoToneColor={"white"} />}
									onClick={async () => {
										await saveJob(record.id, record.jobType);
									}}
								/>
							</Tooltip>
						)}
					</Flex>
				);
			},
		},
	].filter(Boolean);

	const saveJob = async (id, jobType2) => {
		try {
			setLoadingTable(true);
			let currentJob = {};
			if (jobType2 === "Scheduled") {
				const index = scheduledJobs.findIndex((i) => i.id === id);
				if (index !== -1) {
					currentJob = scheduledJobs[index];
				}
			} else if (jobType2 === "Pouring") {
				const index = pouringJobs.findIndex((i) => i.id === id);
				if (index !== -1) {
					currentJob = pouringJobs[index];
				}
			} else if (jobType2 === "Poured") {
				const index = pouredJobs.findIndex((i) => i.id === id);
				if (index !== -1) {
					currentJob = pouredJobs[index];
				}
			} else if (jobType2 === "Regular") {
				const index = regularJobs.findIndex((i) => i.id === id);
				if (index !== -1) {
					currentJob = regularJobs[index];
				}
			}

			const exist = await getInvoiceExistance(id);
			if (!exist && job.jobStatus === "Operations done (AR)") {
				setLoadingTable(false);
				openNotification(
					"warning",
					"Warning",
					"You can't save changes until invoice is generated",
				);
				return;
			}

			if (
				currentJob.jobStatus === "Confirm" ||
				currentJob.jobStatus === "Active"
			) {
				await updateLoad("waiting", id);
			}
			if (
				currentJob.jobStatus === "Operations done (AR)" ||
				currentJob.jobStatus === "ok"
			) {
				await updateLoad("done", id);
			}

			let newJob = {
				jobStatus: currentJob.jobStatus,
				loadYD3: currentJob.loadYD3,
				updatedBy: localStorage.getItem("userId"),
				hold: currentJob.creditHold,
				approved: currentJob.confirm,
				comments: currentJob.comments,
				logisticComment: currentJob.logisticComment,
				logisticConfirmation: currentJob.logisticConfirmation,
			};

			if (!dayjs(currentJob.time).isSame(dayjs(currentJob.scheduledDate))) {
				newJob.scheduledDate = dayjs(currentJob.scheduledDate).toDate();
			}

			if (currentJob.jobStatus !== currentJob.jobStatusPrev) {
				newJob.jobStatusHistory = {
					user: localStorage.getItem("userId"),
					jobStatus: currentJob.jobStatus,
				};
			}

			if (currentJob.jobStatus === "Ready to Load") {
				newJob.readyToBeScheduledDate = dayjs(
					currentJob.readyToBeScheduledDate,
				).toDate();
			} else if (
				currentJob.jobStatus === "ok" ||
				currentJob.jobStatus === "Active"
			) {
				if (currentJob.isOver30) newJob.pour = currentJob.checkInValues.pour;
			}

			if (currentJob.isOver30) {
				if (
					currentJob.checkInValues.measurement === false &&
					localStorage.getItem("email") !== "eliud@gmail.com"
				) {
					if (newJob.jobStatus === "Ready to Load") {
						setLoadingTable(false);
						openNotification(
							"warning",
							"Warning",
							"You must check in to change the status Ready To Be Scheduled",
						);
						return;
					}
				} else {
					if (currentJob.currentMeasurement === false) {
						newJob.checkInLatitude = checkInLatitude;
						newJob.checkInLongitude = checkInLongitude;
					}
					newJob.measurement = currentJob.checkInValues.measurement;
					newJob.measurementYards = currentJob.checkInValues.measurementYards;
					newJob.readyForTruck = currentJob.checkInValues.readyForTruck;
					newJob.readyForTruckComments =
						currentJob.checkInValues.readyForTruckComments;
					newJob.lightTowerPositions =
						currentJob.checkInValues.lightTowerPositions;
					newJob.lightTowerPositionsNumberTag =
						currentJob.checkInValues.lightTowerPositionsNumberTag;
					newJob.lightTowerPositionsBrand =
						currentJob.checkInValues.lightTowerPositionsBrand;
				}
			}

			if (currentJob.delayedPouringComment !== "") {
				newJob.delayedPouringComment = currentJob.delayedPouringComment;
			}

			if (cannotChangeStatus.current && currentJob.isOver30) {
				setLoadingTable(false);
				openNotification(
					"warning",
					"Warning",
					"You cannot save job until Check In is made",
				);
				return;
			}

			const url = api + "/job/" + id;
			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			await axios.patch(url, newJob);

			jobId.current = null;
			job.current = null;
			jobNumber.current = null;
			customerId.current = null;
			shipAddress.current = null;
			latitude.current = null;
			longitude.current = null;
			plantId.current = null;
			typeSend.current = null;
			jobType.current = null;
			logisticConfirmation.current = null;
			cannotChangeStatus.current = false;
			checkInValuesForm.current = null;
			comments.current = null;

			setRefresh((prev) => !prev);

			openNotification("success", "Success", "Job Updated");

			setLoadingTable(false);
		} catch (error) {
			setLoadingTable(false);
			openNotification("error", "Error", "Cannot update job");
			console.error(error.message);
		}
	};

	const updateLoad = async (status, id) => {
		const url = api + "/load/" + id;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			const body = {
				status: status,
			};
			if (data.length !== 0) {
				data.forEach(async (load) => {
					const urlUpdate = api + "/load/" + load._id;
					await axios.patch(urlUpdate, body);
				});
			}
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const getInvoiceExistance = async (id) => {
		const url = api + "/jobinvoice/" + id;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			await axios.get(url);
			return true;
		} catch (err) {
			return false;
		}
	};

	const handleCheckInOpen = async (
		latitude,
		longitude,
		checkInLatitude,
		checkInLongitude,
		measurement,
		isOver30,
	) => {
		if (measurement === false && isOver30) {
			const isInCoords = await checkSellerPosition(
				latitude,
				longitude,
				checkInLatitude,
				checkInLongitude,
			);
			if (isInCoords) {
				cannotChangeStatus.current = false;
				setOpenCheckInModal(true);
			} else {
				cannotChangeStatus.current = true;
				openNotification(
					"warning",
					"Warning",
					"You must be at job direction to make check in",
				);
			}
		} else {
			if (isOver30) {
				setOpenCheckInModal(true);
			}
			cannotChangeStatus.current = false;
		}
	};

	const checkSellerPosition = async (
		jobLatitude,
		jobLongitude,
		checkInLatitude,
		checkInLongitude,
	) => {
		const url = api + `/job/seller/position`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const body = {
				sellerLatitude: checkInLatitude,
				sellerLongitude: checkInLongitude,
				jobLatitude: jobLatitude,
				jobLongitude: jobLongitude,
			};
			const { data } = await axios.post(url, body);
			if (data.success) {
				return data.payload;
			} else {
				return false;
			}
		} catch (err) {
			console.error(err.message);
			return false;
		}
	};

	const generateStatement = async (customerId) => {
		try {
			setLoadingTable(true);
			const start = `${startDate.year()}-${
				startDate.month() + 1
			}-${startDate.date()}`;

			const url =
				api +
				`/invoice/statement/customer/pdf/${customerId}?startDate=${start}&endDate=${start}`;
			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			try {
				const { data } = await axios.post(url);
				if (data.success) {
					setLoadingTable(false);

					window.open(data.payload, "_blank");
				} else {
					setLoadingTable(false);
					openNotification("error", "Error", data.message);
				}
			} catch (err) {
				setLoadingTable(false);
				openNotification("error", "Error", "Cannot generate statement");
				console.error(err);
				return null;
			}
		} catch (e) {
			console.error(e.message);
		}
	};

	const generateStatementPayment = async (customerId) => {
		try {
			setLoadingTable(true);
			const start = `${startDate.year()}-${
				startDate.month() + 1
			}-${startDate.date()}`;

			const url =
				api +
				`/invoice/payment/customer/pdf/${customerId}?startDate=${start}&endDate=${start}`;
			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			try {
				const { data } = await axios.post(url);
				if (data.success) {
					setLoadingTable(false);

					window.open(data.payload, "_blank");
				} else {
					setLoadingTable(false);
					openNotification("error", "Error", data.message);
				}
			} catch (err) {
				setLoadingTable(false);
				openNotification("error", "Error", "Cannot generate statement");
				console.error(err);
				return null;
			}
		} catch (e) {
			console.error(e.message);
		}
	};

	useEffect(() => {
		getJobs();
	}, [startDate, seller, customer, plant, refresh]);

	useEffect(() => {
		getSellers();
		getCustomers();
		getPlants();
		getLocation();
	}, []);

	const getLocation = () => {
		if (navigator.geolocation) {
			// Success callback
			navigator.geolocation.getCurrentPosition(
				(position) => {
					setCheckInLatitude(position.coords.latitude);
					setCheckInLongitude(position.coords.longitude);
				},
				// Error callback
				(error) => {
					setCheckInLatitude(undefined);
					setCheckInLongitude(undefined);
					openNotification("warning", "Warning", error.message);
				},
			);
		} else {
			setCheckInLatitude(undefined);
			setCheckInLongitude(undefined);
			openNotification(
				"warning",
				"Warning",
				"Geolocation is not supported by this browser.",
			);
		}
	};

	const getSellers = async () => {
		const url = api + "/user/list/role/Seller";
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			if (data.success) {
				let list = [{ value: "All", label: "All Sellers" }];
				data.payload.map((item) => {
					if (
						item.name === "Abraham Benavides" ||
						item.name === "CORPORATIVO" ||
						item.name === "David Santamaria" ||
						item.name === "Edgar Briones" ||
						item.name === "Eleazar Castillo" ||
						item.name === "Eliud Cavazos" ||
						item.name === "Erik Pecina" ||
						item.name === "Ernesto Vazquez" ||
						item.name === "Fermin Avendaño" ||
						item.name === "Javier Benavides Comercial" ||
						item.name === "Javier Benavides Residencial" ||
						item.name === "Jesus Cantu" ||
						item.name === "Juan Hernandez" ||
						item.name === "Juan Valenzuela" ||
						item.name === "Ramon Luna"
					) {
						list.push({
							value: item._id,
							label: item.name,
						});
					}
				});
				setOptionsSellers(list);
			} else {
				openNotification("error", "Error", data.message);
			}
			setLoadingSeller(false);
		} catch (err) {
			console.error(err.message);
			setLoadingSeller(false);
			openNotification("error", "Error", "Error while trying to get sellers");
			return null;
		}
	};

	const getCustomers = async () => {
		try {
			const url = api + "/customer/list/options/57Concrete";
			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			const { data } = await axios.get(url);
			if (data.success) {
				let list = [];
				data.payload.map((item) => {
					list.push({
						label: `${item.customerNumber} ${item.name}`,
						value: item._id,
					});
				});
				setCustomerList(list);
			} else {
				openNotification("error", "Error", data.message);
			}
			setCustomerLoading(false);
		} catch (err) {
			setCustomerLoading(false);
			openNotification("error", "Error", "Error while trying to get customers");
			console.error(err.message);
			return null;
		}
	};

	const getPlants = async () => {
		try {
			const url = api + "/plant/list/57Concrete";
			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			const { data } = await axios.get(url);
			if (data.success) {
				let list = [];
				data.payload
					.filter((item) => item.name !== "Laredo")
					.map((item) => {
						list.push({
							value: item._id,
							label: item.name,
						});
					});
				setOptionsPlant(list);
			} else {
				openNotification("error", "Error", data.message);
			}

			setLoadingPlant(false);
		} catch (err) {
			setLoadingPlant(false);
			openNotification("error", "Error", "Error while trying to get plants");
			console.error(err.message);
			return null;
		}
	};

	const getJobs = async () => {
		try {
			setLoading(true);
			const start = `${startDate.year()}-${
				startDate.month() + 1
			}-${startDate.date()}`;

			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
			const url =
				api +
				`/job/get/invoice/totals?startDate=${start}&endDate=${start}&customer=${customer}&seller=${seller}&plant=${plant}`;
			const { data } = await axios.get(url);
			if (data.success) {
				const dataList = [];
				data.payload.map((job, index) => {
					let invoiceTotal = 0;

					let overDueTotal = 0;

					job.invoices.map((invoice) => {
						if (invoice.balance) {
							invoiceTotal += invoice.balance;
						} else {
							invoiceTotal += invoice.invoiceTotal;
						}

						const invoiceDate = dayjs(invoice.invoiceDate);
						const currentDate = dayjs();

						const paymentTerm = invoice.paymentTerm;
						if (paymentTerm === "7") {
							if (currentDate.diff(invoiceDate, "day") > 7) {
								if (invoice.balance) {
									overDueTotal += invoice.balance;
								} else {
									overDueTotal += invoice.invoiceTotal;
								}
							}
						} else if (paymentTerm === "14") {
							if (currentDate.diff(invoiceDate, "day") > 14) {
								if (invoice.balance) {
									overDueTotal += invoice.balance;
								} else {
									overDueTotal += invoice.invoiceTotal;
								}
							}
						} else if (paymentTerm === "21") {
							if (currentDate.diff(invoiceDate, "day") > 21) {
								if (invoice.balance) {
									overDueTotal += invoice.balance;
								} else {
									overDueTotal += invoice.invoiceTotal;
								}
							}
						} else if (paymentTerm === "30") {
							if (currentDate.diff(invoiceDate, "day") > 30) {
								if (invoice.balance) {
									overDueTotal += invoice.balance;
								} else {
									overDueTotal += invoice.invoiceTotal;
								}
							}
						} else if (paymentTerm === "Prepayment") {
							if (invoice.balance) {
								overDueTotal += invoice.balance;
							} else {
								overDueTotal += invoice.invoiceTotal;
							}
						}
					});

					let restrict = false;
					let confirm = false;
					const tipoPago = job.customer.paymentType;
					const validado = job.approved;

					if (
						localStorage.getItem("role") === "Finance" ||
						tipoPago !== "PrePay" ||
						validado
					) {
						restrict = false;
					} else {
						restrict = true;
					}

					// regla para habilitar el confirm
					if (validado) {
						confirm = true;
					} else {
						if (
							localStorage.getItem("role") === "Finance" ||
							tipoPago !== "Credit"
						) {
							confirm = true;
						} else {
							confirm = false;
						}
					}

					// Excepcion i el cliente esta en credit hold no dejar editar nada
					if (job.hold) {
						confirm = false;
					}

					let sumYards = 0;
					let isOver30 = false;
					let currentMeasurement = false;
					let checkInValues = {};
					if (job.targetYD3) {
						sumYards += job.targetYD3;
					}
					if (job.balance) {
						sumYards += job.balance;
					}
					if (sumYards < 50) {
						isOver30 = false;
					} else if (sumYards >= 50) {
						isOver30 = true;
						currentMeasurement = job.measurement || false;

						checkInValues = {
							measurement: job.measurement || false,
							measurementYards: job.measurementYards || undefined,
							readyForTruck: job.readyForTruck || false,
							readyForTruckComments: job.readyForTruckComments || undefined,
							lightTowerPositions: job.lightTowerPositions || false,
							lightTowerPositionsNumberTag:
								job.lightTowerPositionsNumberTag || undefined,
							lightTowerPositionsBrand:
								job.lightTowerPositionsBrand || undefined,
							pour: job.pour || false,
							jobStatus: job.jobStatus,
						};
					}

					let status = job.jobStatus;
					let jobStatus2 = job.jobStatus;
					if (status === "ok") {
						jobStatus2 = "Poured";
					} else if (status === "Active") {
						jobStatus2 = "Pouring";
					} else if (status === "Confirm") {
						jobStatus2 = "A/R Confirmed";
					} else if (status === "Ready to Load") {
						jobStatus2 = "Ready to be scheduled";
					}

					dataList.push({
						key: job._id,
						index: index,
						id: job._id,
						jobId: job.number,
						projectAddress: `${job.customerShipAddress} - ${job.shipAddress}`,
						seller: job.seller.name,
						loadYD3: job.loadYD3,
						customer: `${job.customer.customerNumber} ${job.customer.name}`,
						customerId: job.customer._id,
						mixDesign: job.psiId ? job.psiId.psi : job.psi,
						salesPrice: job.unitPrice,
						totalAmount: job.invoice ? job.invoice.invoiceTotal : 0,
						authorizedCreditLimit: job.customer.creditAmount,
						openBalance: invoiceTotal,
						overdueBalance: overDueTotal,
						invoice: job.invoice,
						franchise: job.franchise || "57Concrete",
						jobStatus: job.jobStatus,
						jobStatus2: jobStatus2,
						jobStatusPrev: job.jobStatus,
						time: dayjs(job.scheduledDate),
						jobType:
							job.jobStatus === "Scheduled"
								? "Scheduled"
								: job.jobStatus === "ok"
									? "Poured"
									: job.jobStatus === "Active"
										? "Pouring"
										: "Regular",
						shipAddress: job.shipAddress,
						customerShipAddress: job.customerShipAddress,
						plant: job.plant.name,
						latitude: job.latitude,
						longitude: job.longitude,
						plantId: job.plant._id,
						targetYD3: job.targetYD3,
						balance: job.balance,
						destinationTime: job.destinationTime,
						destinationMinutes: job.destinationMinutes,
						scheduledDate: dayjs(job.scheduledDate),
						slump: job.slump,
						job: job,
						logisticConfirmation: job.logisticConfirmation || false,
						fiber: job.fiberQuantity && job.fiberQuantity > 0,
						fiberQuantity: job.fiberQuantity,
						minPrice:
							(getAggregateCogsCost(job.aggregate)) + 50,
						pourType: `${job.jobPoor} / ${job.jobType}`,
						readyToBeScheduledDateFormat: job.readyToBeScheduledDate
							? dayjs(job.readyToBeScheduledDate).format("MM/DD/YYYY hh:mm a")
							: "-",
						readyToBeScheduledDate: job.readyToBeScheduledDate,
						measurement: job.measurement || false,
						iceSurcharge: job.iceSurcharge && job.iceSurcharge !== 0,
						lightSurcharge: job.lightSurcharge && job.lightSurcharge !== 0,
						pour: job.pour || false,
						creditHold: job.hold,
						restrict: restrict,
						confirm: confirm,
						customerCreditHold: job.customer.creditHold,
						approvedPrice: job.approvedPrice || false,
						jobStatusSellerChange: false,
						isOver30: isOver30,
						currentMeasurement: currentMeasurement,
						checkInValues: checkInValues,
						checkInLatitude: job.checkInLatitude,
						checkInLongitude: job.checkInLongitude,
						comments: job.comments,
					});
				});

				const filterRegularJobs = dataList.filter(
					(d) =>
						d.jobStatus !== "Scheduled" &&
						d.jobStatus !== "ok" &&
						d.jobStatus !== "Active",
				);
				const filterScheduledJobs = dataList.filter(
					(d) => d.jobStatus === "Scheduled",
				);
				const filterPouringJobs = dataList.filter(
					(d) => d.jobStatus === "Active",
				);
				const filterPouredJobs = dataList.filter((d) => d.jobStatus === "ok");

				setRegularJobs(filterRegularJobs);
				setScheduledJobs(filterScheduledJobs);
				setPouringJobs(filterPouringJobs);
				setPouredJobs(filterPouredJobs);
				assignDataTarget(dataList);
			} else {
				openNotification("error", "Error", data.message);
			}
			setLoadingTable(false);
			setLoading(false);
		} catch (err) {
			console.error(err.message);
			openNotification("error", "Error", "Error while trying to get jobs");
			return null;
		}
	};

	const assignDataTarget = (data) => {
		const scheduledData = data.filter((job) => job.jobStatus === "Scheduled");
		const scheduledYards = scheduledData.reduce(
			(accum, current) => accum + current.targetYD3,
			0,
		);
		setScheduledTargetYD3(scheduledYards);

		const pouringData = data.filter((job) => job.jobStatus === "Active");
		const pouringYards = pouringData.reduce(
			(accum, current) => accum + current.targetYD3,
			0,
		);
		const pouringLoads = pouringData.reduce(
			(accum, current) => accum + current.loadYD3,
			0,
		);
		setPouringTargetYD3(pouringYards);
		setPouringLoadYD3(pouringLoads);

		const pouredData = data.filter((job) => job.jobStatus === "ok");
		const pouredLoads = pouredData.reduce(
			(accum, current) => accum + current.loadYD3,
			0,
		);
		setPouredLoadYD3(pouredLoads);

		const readyData = data.filter((job) => job.jobStatus === "Ready to Load");
		const readyYards = readyData.reduce(
			(accum, current) => accum + current.targetYD3,
			0,
		);
		setReadyTargetYD3(readyYards);

		let tagetSum = 0;
		let loadSum = 0;
		let waitSum = 0;
		let balanceSum = 0;

		data.map((element) => {
			let operandos =
				typeof element.targetYD3 === "string"
					? element.targetYD3.split("+")
					: element.targetYD3;
			if (
				element.jobStatus !== "Quote" &&
				element.jobStatus !== "Waiting Inspection" &&
				element.jobStatus !== "Wait Inspection" &&
				element.jobStatus !== "Company cancellation" &&
				element.jobStatus !== "Customer cancellation" &&
				element.jobStatus !== "Trouble" &&
				element.jobStatus !== "New Order"
			) {
				tagetSum +=
					typeof element.targetYD3 === "string"
						? parseFloat(operandos[0])
						: operandos;
			}

			if (
				element.jobStatus === "Waiting Inspection" ||
				element.jobStatus === "Wait Inspection"
			) {
				waitSum +=
					typeof element.targetYD3 === "string"
						? parseFloat(operandos[0])
						: operandos;
			}

			var balance = element.balance ? element.balance : 0;
			balanceSum += parseFloat(balance);

			if (
				element.jobStatus === "ok" ||
				element.jobStatus === "Confirm" ||
				element.jobStatus === "Operations done (AR)" ||
				element.jobStatus === "Scheduled" ||
				element.jobStatus === "Date moved" ||
				element.jobStatus === "Active" ||
				element.jobStatus === "Ready to Load" ||
				element.jobStatus === "Waiting Inspection"
			) {
				loadSum += element.loadYD3;
			}
		});

		loadSum = Math.round(loadSum * 100) / 100;

		setTotalLoadYards(loadSum);
		setTotalTargetYards(tagetSum);
		setTotalBalanceYards(balanceSum);
		setTotalWaitYards(waitSum);

		getGlobalYards();
	};

	const getGlobalYards = async () => {
		const fecha = `${startDate.year()}-${
			startDate.month() + 1
		}-${startDate.date()}`;
		const url = api + `/job/get/global/yards?date=${fecha}`;

		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			if (data.success) {
				const globalYards = data.payload.reduce(
					(acc, job) => acc + job.loadYD3,
					0,
				);
				setTotalGlobalYards(globalYards);
			}
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const onDateChange = (date) => {
		if (date) {
			setStartDate(date);
		}
	};

	const filterOption = (input, option) =>
		(option?.label ?? "").toLowerCase().includes(input.toLowerCase());

	const RenderSearch = () => {
		return (
			<Flex vertical gap={8}>
				<h3>
					{`Total YD: ${toThousands(totalLoadYards)}, 
                    Total Target: ${toThousands(
											parseFloat(totalTargetYards).toFixed(2),
										)}, 
                    Total Balance: ${toThousands(
											parseFloat(totalBalanceYards).toFixed(2),
										)},
                    Waiting Inspection: ${toThousands(
											parseFloat(totalWaitYards).toFixed(2),
										)}, Global Total YD: ${toThousands(
											parseFloat(totalGlobalYards).toFixed(2),
										)}`}
				</h3>
				<Flex gap={8}>
					<DatePicker
						defaultValue={dayjs(startDate, "MM/DD/YYYY")}
						onChange={onDateChange}
						format={"MM/DD/YYYY"}
						size="large"
						disabled={loading}
						allowClear={false}
					/>
					<Select
						showSearch
						placeholder={`Select plant`}
						optionFilterProp="children"
						size="large"
						onChange={(value) => setPlant(value)}
						filterOption={filterOption}
						options={optionsPlant}
						disabled={loadingPlant || loading}
						value={plant}
						style={{
							width: "200px",
						}}
						allowClear={false}
					/>
					<Select
						showSearch
						placeholder={`Select seller`}
						optionFilterProp="children"
						size="large"
						onChange={(value) => setSeller(value)}
						filterOption={filterOption}
						options={optionsSellers}
						disabled={loadingSeller || loading}
						value={seller}
						defaultValue={"All"}
						style={{
							width: "200px",
						}}
						allowClear
					/>
					<Select
						showSearch
						placeholder={`Select customer`}
						optionFilterProp="children"
						size="large"
						onChange={(value) => setCustomer(value)}
						filterOption={filterOption}
						options={customerList}
						disabled={customerLoading || loading}
						value={customer}
						style={{
							width: "200px",
						}}
						allowClear
					/>
				</Flex>
			</Flex>
		);
	};

	const RenderJobTable = () => {
		return (
			<Flex gap={"middle"} vertical>
				{regularJobs.length !== 0 && (
					<Table
						title={() => (
							<Flex vertical gap={16}>
								<Title>Regular Jobs</Title>
								<Text strong>Total TargetYD3: {readyTargetYD3}</Text>
							</Flex>
						)}
						columns={columns}
						dataSource={regularJobs}
						pagination={{
							position: ["bottomRight"],
							pageSizeOptions: [10, 20, 50, 100, 250, 500],
							defaultPageSize: 20,
							showSizeChanger: true,
						}}
						scroll={{ x: 3000 }}
						loading={loading || loadingTable}
					/>
				)}
				{scheduledJobs.length !== 0 && (
					<Table
						title={() => (
							<Flex vertical gap={16}>
								<Title>Scheduled Jobs</Title>
								<Text strong>Total TargetYD3: {scheduledTargetYD3}</Text>
							</Flex>
						)}
						columns={columns}
						dataSource={scheduledJobs}
						pagination={{
							position: ["bottomRight"],
							pageSizeOptions: [10, 20, 50, 100, 250, 500],
							defaultPageSize: 20,
							showSizeChanger: true,
						}}
						scroll={{ x: 3000 }}
						loading={loading || loadingTable}
					/>
				)}
				{pouringJobs.length !== 0 && (
					<Table
						title={() => (
							<Flex vertical gap={16}>
								<Title>Pouring Jobs</Title>
								<Text strong>Total TargetYD3: {pouringTargetYD3}</Text>
								<Text strong>Total LoadYD3: {pouringLoadYD3}</Text>
							</Flex>
						)}
						columns={columns}
						dataSource={pouringJobs}
						pagination={{
							position: ["bottomRight"],
							pageSizeOptions: [10, 20, 50, 100, 250, 500],
							defaultPageSize: 20,
							showSizeChanger: true,
						}}
						scroll={{ x: 3000 }}
						loading={loading || loadingTable}
					/>
				)}
				{pouredJobs.length !== 0 && (
					<Table
						title={() => (
							<Flex vertical gap={16}>
								<Title>Poured Jobs</Title>
								<Text strong>Total LoadYD3: {pouredLoadYD3}</Text>
							</Flex>
						)}
						columns={columns}
						dataSource={pouredJobs}
						pagination={{
							position: ["bottomRight"],
							pageSizeOptions: [10, 20, 50, 100, 250, 500],
							defaultPageSize: 20,
							showSizeChanger: true,
						}}
						scroll={{ x: 3000 }}
						loading={loading || loadingTable}
					/>
				)}
			</Flex>
		);
	};

	const paymentsUpdated = () => {
		getJobs();
		setModalInvoiceOpen(false);
		jobId.current = null;
	};

	const RenderModalInvoice = () => {
		return (
			<Modal
				title="Invoice Payments"
				open={modalInvoiceOpen}
				onCancel={() => setModalInvoiceOpen(false)}
				cancelButtonProps={{ style: { display: "none" } }}
				okButtonProps={{ style: { display: "none" } }}
				width={1200}
			>
				<PaymentJob2 jobId={jobId.current} pcb={paymentsUpdated} />
			</Modal>
		);
	};

	const paymentsUpdatedOpenInvoices = () => {
		getJobs();
		setModalOpenInvoicesOpen(false);
		customerId.current = null;
	};

	const RenderModalOpenInvoices = () => {
		return (
			<Modal
				title="Open Invoices"
				open={modalOpenInvoicesOpen}
				onCancel={paymentsUpdatedOpenInvoices}
				cancelButtonProps={{ style: { display: "none" } }}
				okButtonProps={{ style: { display: "none" } }}
				width={1200}
				centered
			>
				<OpenInvoices customerId={customerId.current} />
			</Modal>
		);
	};

	const onCloseModalAddress = () => {
		latitude.current = null;
		longitude.current = null;
		shipAddress.current = null;
		plantId.current = null;
		setModalOpenJobAddress(false);
	};

	const RenderModalJobAddress = () => {
		return (
			<Modal
				title={shipAddress.current}
				open={modalOpenJobAddress}
				onCancel={onCloseModalAddress}
				cancelButtonProps={{ style: { display: "none" } }}
				okButtonProps={{ style: { display: "none" } }}
				width={1200}
				centered
			>
				<AddressJob
					lat={latitude.current}
					lng={longitude.current}
					address={shipAddress.current}
					plant={plantId.current}
				/>
			</Modal>
		);
	};

	const getLoadData = async () => {
		try {
			setLoadingTable(true);
			const url = api + "/load/" + jobId.current;
			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			const { data } = await axios.get(url);
			const suma = data
				.map((viaje) => viaje.yards)
				.reduce((acc, acum) => acc + acum, 0);

			const urlJob = api + "/job/" + jobId.current;
			const updateJob = {
				loadYD3: Math.round(suma * 100) / 100,
			};
			await axios.patch(urlJob, updateJob);

			if (jobType.current === "Scheduled") {
				const newJobs = [...scheduledJobs];
				const index = newJobs.findIndex((i) => i.id === jobId.current);
				if (index !== -1) {
					newJobs[index] = {
						...newJobs[index],
						loadYD3: Math.round(suma * 100) / 100,
					};
					setScheduledJobs(newJobs);
					assignDataTarget([
						...newJobs,
						...pouringJobs,
						...pouredJobs,
						...regularJobs,
					]);
				}
			} else if (jobType.current === "Pouring") {
				const newJobs = [...pouringJobs];
				const index = newJobs.findIndex((i) => i.id === jobId.current);
				if (index !== -1) {
					newJobs[index] = {
						...newJobs[index],
						loadYD3: Math.round(suma * 100) / 100,
					};
					setPouringJobs(newJobs);
					assignDataTarget([
						...newJobs,
						...scheduledJobs,
						...pouredJobs,
						...regularJobs,
					]);
				}
			} else if (jobType.current === "Poured") {
				const newJobs = [...pouredJobs];
				const index = newJobs.findIndex((i) => i.id === jobId.current);
				if (index !== -1) {
					newJobs[index] = {
						...newJobs[index],
						loadYD3: Math.round(suma * 100) / 100,
					};
					setPouredJobs(newJobs);
					assignDataTarget([
						...newJobs,
						...scheduledJobs,
						...pouringJobs,
						...regularJobs,
					]);
				}
			} else if (jobType.current === "Regular") {
				const newJobs = [...regularJobs];
				const index = newJobs.findIndex((i) => i.id === jobId.current);
				if (index !== -1) {
					newJobs[index] = {
						...newJobs[index],
						loadYD3: Math.round(suma * 100) / 100,
					};
					setRegularJobs(newJobs);
					assignDataTarget([
						...newJobs,
						...scheduledJobs,
						...pouringJobs,
						...pouredJobs,
					]);
				}
			}
			jobId.current = null;
			job.current = null;
			jobType.current = null;
			jobNumber.current = null;
			setLoadingTable(false);
		} catch (err) {
			jobId.current = null;
			job.current = null;
			jobType.current = null;
			jobNumber.current = null;
			openNotification("error", "Error", "Cannot update loads");
			console.error(err.message);
			return null;
		}
	};

	const onCloseModalAddLoad = async () => {
		setModalOpenAddLoad(false);
		await getLoadData();
	};

	const onCloseModalLogisticsComment = () => {
		setModalOpenLogisticsComment(false);
	};

	const onFinishLogistics = (values) => {
		logisticConfirmation.current = !logisticConfirmation.current;
		setLoadingButtonLogistics(true);
		if (jobType.current === "Scheduled") {
			const newJobs = [...scheduledJobs];
			const index = newJobs.findIndex((i) => i.id === jobId.current);
			if (index !== -1) {
				newJobs[index] = {
					...newJobs[index],
					logisticComment: values.comment,
					logisticConfirmation: !logisticConfirmation.current,
				};
				setScheduledJobs(newJobs);
			}
		} else if (jobType.current === "Pouring") {
			const newJobs = [...pouringJobs];
			const index = newJobs.findIndex((i) => i.id === jobId.current);
			if (index !== -1) {
				newJobs[index] = {
					...newJobs[index],
					logisticComment: values.comment,
					logisticConfirmation: !logisticConfirmation.current,
				};
				setPouringJobs(newJobs);
			}
		} else if (jobType.current === "Poured") {
			const newJobs = [...pouredJobs];
			const index = newJobs.findIndex((i) => i.id === jobId.current);
			if (index !== -1) {
				newJobs[index] = {
					...newJobs[index],
					logisticComment: values.comment,
					logisticConfirmation: !logisticConfirmation.current,
				};
				setPouredJobs(newJobs);
			}
		} else if (jobType.current === "Regular") {
			const newJobs = [...regularJobs];
			const index = newJobs.findIndex((i) => i.id === jobId.current);
			if (index !== -1) {
				newJobs[index] = {
					...newJobs[index],
					logisticComment: values.comment,
					logisticConfirmation: !logisticConfirmation.current,
				};
				setRegularJobs(newJobs);
			}
		}
		formLogistics.resetFields();
		setLoadingButtonLogistics(false);
		onCloseModalLogisticsComment();
	};

	const addLoadModal = useMemo(
		() => (
			<Modal
				destroyOnClose={false}
				title={
					<Row gutter={16}>
						<Col span={24}>Load YD3. JobID = {jobNumber.current}</Col>
						<Col span={24}>
							{[
								"mv@57concrete.com",
								"al@57concrete.com",
								"ec@57concrete.com",
								"pc@57concrete.com",
								"jc@57concrete.com",
								"gg@57xgroup.com",
								"fc@57concrete.com",
								"bp@57concrete.com",
								"bpa@57concrete.com",
								"vm@57concrete.com",
								"jp@57concrete.com",
								"eliud@gmail.com",
							].includes(localStorage.getItem("email")) && (
								<Button
									danger={logisticConfirmation.current === false}
									type="primary"
									onClick={(e) => {
										e.stopPropagation(); // prevents triggering modal close
										setModalOpenLogisticsComment(true);
									}}
								>
									Logistics confirmation
								</Button>
							)}
						</Col>
					</Row>
				}
				open={modalOpenAddLoad}
				onCancel={onCloseModalAddLoad}
				cancelButtonProps={{ style: { display: "none" } }}
				okButtonProps={{ style: { display: "none" } }}
				width={1200}
				centered
			>
				<LoadJob job={job.current} />
			</Modal>
		),
		[modalOpenAddLoad, logisticConfirmation.current],
	); // only re-render if modalOpenAddLoad changes

	// 🧱 Separate, independent memoized modal for logistics comment
	const logisticsCommentModal = useMemo(
		() => (
			<Modal
				destroyOnClose={false}
				title="Add comment to logistic confirmation"
				open={modalOpenLogisticsComment}
				onCancel={onCloseModalLogisticsComment}
				cancelButtonProps={{ style: { display: "none" } }}
				okButtonProps={{ style: { display: "none" } }}
				width={600}
				centered
			>
				<Form
					form={formLogistics}
					layout="vertical"
					onFinish={onFinishLogistics}
					style={{ marginTop: "20px" }}
				>
					<Row gutter={16}>
						<Col span={24}>
							<Form.Item
								label="Comment"
								name="comment"
								rules={[
									{
										required: true,
										message: "Comment is required",
									},
								]}
							>
								<Input size="large" placeholder="Enter comment" />
							</Form.Item>
						</Col>
						<Col span={24}>
							<Button
								type="primary"
								htmlType="submit"
								loading={loadingButtonLogistics}
								size="large"
								style={{ width: "100%" }}
								icon={<SaveFilled twoToneColor="white" />}
							>
								Save
							</Button>
						</Col>
					</Row>
				</Form>
			</Modal>
		),
		[modalOpenLogisticsComment, loadingButtonLogistics],
	);

	const onSendStatement = () => {
		customerId.current = null;
		typeSend.current = null;
		setModalSendOpen(false);
	};

	const RenderModalSend = () => {
		return (
			<Modal
				title="Send Statements"
				open={modalSendOpen}
				onCancel={() => setModalSendOpen(false)}
				cancelButtonProps={{ style: { display: "none" } }}
				okButtonProps={{ style: { display: "none" } }}
				width={600}
				centered
			>
				<SendStatements
					customerId={customerId.current}
					isEmail={typeSend.current === "email"}
					pcb={onSendStatement}
					startDate={startDate}
					endDate={startDate}
				/>
			</Modal>
		);
	};

	const handleCheckInCancel = () => {
		setOpenCheckInModal(false);
	};

	const setCheckInValues = (values) => {
		setLoadingTable(true);
		if (jobType.current === "Scheduled") {
			const newJobs = [...scheduledJobs];
			const index = newJobs.findIndex((i) => i.id === jobId.current);
			if (index !== -1) {
				const checkInValues = {
					...newJobs[index].checkInValues,
					measurement: values.measurement,
					measurementYards: values.measurementYards,
					readyForTruck: values.readyForTruck,
					readyForTruckComments: values.readyForTruckComments,
					lightTowerPositions: values.lightTowerPositions,
					lightTowerPositionsNumberTag: values.lightTowerPositionsNumberTag,
					lightTowerPositionsBrand: values.lightTowerPositionsBrand,
					pour: values.pour,
				};

				newJobs[index] = {
					...newJobs[index],
					checkInValues: checkInValues,
				};
				setScheduledJobs(newJobs);
			}
		} else if (jobType.current === "Pouring") {
			const newJobs = [...pouringJobs];
			const index = newJobs.findIndex((i) => i.id === jobId.current);
			if (index !== -1) {
				const checkInValues = {
					...newJobs[index].checkInValues,
					measurement: values.measurement,
					measurementYards: values.measurementYards,
					readyForTruck: values.readyForTruck,
					readyForTruckComments: values.readyForTruckComments,
					lightTowerPositions: values.lightTowerPositions,
					lightTowerPositionsNumberTag: values.lightTowerPositionsNumberTag,
					lightTowerPositionsBrand: values.lightTowerPositionsBrand,
					pour: values.pour,
				};
				newJobs[index] = {
					...newJobs[index],
					checkInValues: checkInValues,
				};
				setPouringJobs(newJobs);
			}
		} else if (jobType.current === "Poured") {
			const newJobs = [...pouredJobs];
			const index = newJobs.findIndex((i) => i.id === jobId.current);
			if (index !== -1) {
				const checkInValues = {
					...newJobs[index].checkInValues,
					measurement: values.measurement,
					measurementYards: values.measurementYards,
					readyForTruck: values.readyForTruck,
					readyForTruckComments: values.readyForTruckComments,
					lightTowerPositions: values.lightTowerPositions,
					lightTowerPositionsNumberTag: values.lightTowerPositionsNumberTag,
					lightTowerPositionsBrand: values.lightTowerPositionsBrand,
					pour: values.pour,
				};
				newJobs[index] = {
					...newJobs[index],
					checkInValues: checkInValues,
				};
				setPouredJobs(newJobs);
			}
		} else if (jobType.current === "Regular") {
			const newJobs = [...regularJobs];
			const index = newJobs.findIndex((i) => i.id === jobId.current);
			if (index !== -1) {
				const checkInValues = {
					...newJobs[index].checkInValues,
					measurement: values.measurement,
					measurementYards: values.measurementYards,
					readyForTruck: values.readyForTruck,
					readyForTruckComments: values.readyForTruckComments,
					lightTowerPositions: values.lightTowerPositions,
					lightTowerPositionsNumberTag: values.lightTowerPositionsNumberTag,
					lightTowerPositionsBrand: values.lightTowerPositionsBrand,
					pour: values.pour,
				};
				newJobs[index] = {
					...newJobs[index],
					checkInValues: checkInValues,
				};
				setRegularJobs(newJobs);
			}
		}

		checkInValuesForm.current = null;
		jobType.current = null;
		jobId.current = null;

		setLoadingTable(false);
	};

	const RenderCheckInModal = () => {
		return (
			<Modal
				title="Job Check In"
				open={openCheckInModal}
				onCancel={handleCheckInCancel}
				cancelButtonProps={{
					style: { display: "none" },
				}}
				okButtonProps={{
					style: { display: "none" },
				}}
				width={600}
				centered
			>
				{openCheckInModal && checkInValuesForm.current && (
					<JobCheckIn
						values={checkInValuesForm.current}
						setCheckInValues={setCheckInValues}
						handleCheckInCancel={handleCheckInCancel}
					/>
				)}
			</Modal>
		);
	};

	const handleInvoice = () => {
		setShowInvoiceModal((prev) => !prev);
	};

	const RenderInvoiceModal = () => {
		return (
			<Modal
				title="Invoice Generator"
				open={showInvoiceModal}
				onCancel={handleInvoice}
				cancelButtonProps={{
					style: { display: "none" },
				}}
				okButtonProps={{
					style: { display: "none" },
				}}
				width={1000}
				centered
			>
				<JobToInvoiceModal
					jobId={jobId.current}
					pcb={handleInvoice}
					history={history}
				/>
			</Modal>
		);
	};

	const handlePouringModal = () => {
		setShowPouringModal((prev) => !prev);
	};

	const onFinishPouring = (values) => {
		setLoadingButtonPouring(true);
		if (jobType.current === "Scheduled") {
			const newJobs = [...scheduledJobs];
			const index = newJobs.findIndex((i) => i.id === jobId.current);
			if (index !== -1) {
				newJobs[index] = {
					...newJobs[index],
					delayedPouringComment: values.delayedPouringComment,
				};
				setScheduledJobs(newJobs);
			}
		} else if (jobType.current === "Pouring") {
			const newJobs = [...pouringJobs];
			const index = newJobs.findIndex((i) => i.id === jobId.current);
			if (index !== -1) {
				newJobs[index] = {
					...newJobs[index],
					delayedPouringComment: values.delayedPouringComment,
				};
				setPouringJobs(newJobs);
			}
		} else if (jobType.current === "Poured") {
			const newJobs = [...pouredJobs];
			const index = newJobs.findIndex((i) => i.id === jobId.current);
			if (index !== -1) {
				newJobs[index] = {
					...newJobs[index],
					delayedPouringComment: values.delayedPouringComment,
				};
				setPouredJobs(newJobs);
			}
		} else if (jobType.current === "Regular") {
			const newJobs = [...regularJobs];
			const index = newJobs.findIndex((i) => i.id === jobId.current);
			if (index !== -1) {
				newJobs[index] = {
					...newJobs[index],
					delayedPouringComment: values.delayedPouringComment,
				};
				setRegularJobs(newJobs);
			}
		}
		formPouring.resetFields();
		jobId.current = null;
		setLoadingButtonPouring(false);
		handlePouringModal();
	};

	const RenderPouringCommentModal = () => {
		return (
			<Modal
				title="Delayed Pouring Comment"
				open={showPouringModal}
				onCancel={handlePouringModal}
				cancelButtonProps={{
					style: { display: "none" },
				}}
				okButtonProps={{
					style: { display: "none" },
				}}
				width={600}
				centered
			>
				<Form
					form={formPouring}
					layout="vertical"
					onFinish={onFinishPouring}
					style={{ marginTop: "20px" }}
				>
					<Row gutter={16}>
						<Col span={24}>
							<Form.Item
								label="Comment"
								name="delayedPouringComment"
								rules={[
									{
										required: true,
										message: "Comment is required",
									},
								]}
							>
								<Select
									size="large"
									style={{ width: "100%" }}
									placeholder="Enter comment"
									options={delayedPouringElements}
									optionFilterProp="children"
									filterOption={filterOption}
									showSearch
									allowClear={false}
								/>
							</Form.Item>
						</Col>
						<Col span={24}>
							<Button
								type="primary"
								htmlType="submit"
								loading={loadingButtonPouring}
								size="large"
								style={{ width: "100%" }}
								icon={<SaveFilled twoToneColor="white" />}
							>
								Save
							</Button>
						</Col>
					</Row>
				</Form>
			</Modal>
		);
	};

	const handleEditCommentCancel = () => {
		setShowCommentsModal(false);
	};

	const handleEditCommentOpen = () => {
		setShowCommentsModal(true);
	};

	const onFinishComment = (values) => {
		setLoadingButtonComment(true);
		if (jobType.current === "Scheduled") {
			const newJobs = [...scheduledJobs];
			const index = newJobs.findIndex((i) => i.id === jobId.current);
			if (index !== -1) {
				newJobs[index] = {
					...newJobs[index],
					delayedPouringComment: values.delayedPouringComment,
				};
				setScheduledJobs(newJobs);
			}
		} else if (jobType.current === "Pouring") {
			const newJobs = [...pouringJobs];
			const index = newJobs.findIndex((i) => i.id === jobId.current);
			if (index !== -1) {
				newJobs[index] = {
					...newJobs[index],
					comments: values.comments,
				};
				setPouringJobs(newJobs);
			}
		} else if (jobType.current === "Poured") {
			const newJobs = [...pouredJobs];
			const index = newJobs.findIndex((i) => i.id === jobId.current);
			if (index !== -1) {
				newJobs[index] = {
					...newJobs[index],
					comments: values.comments,
				};
				setPouredJobs(newJobs);
			}
		} else if (jobType.current === "Regular") {
			const newJobs = [...regularJobs];
			const index = newJobs.findIndex((i) => i.id === jobId.current);
			if (index !== -1) {
				newJobs[index] = {
					...newJobs[index],
					comments: values.comments,
				};
				setRegularJobs(newJobs);
			}
		}
		formComment.resetFields();
		jobId.current = null;
		jobNumber.current = null;
		comments.current = null;
		setLoadingButtonComment(false);
		handleEditCommentCancel();
	};

	useEffect(() => {
		if (showCommentsModal) {
			formComment.setFieldsValue({
				comments: comments.current || "",
			});
		}
	}, [showCommentsModal, comments.current]);

	const RenderCommentModal = () => {
		return (
			<Modal
				title={`Edit comment of Job #${jobNumber.current}`}
				open={showCommentsModal}
				onCancel={handleEditCommentCancel}
				cancelButtonProps={{
					style: { display: "none" },
				}}
				okButtonProps={{
					style: { display: "none" },
				}}
				width={600}
				centered
			>
				<Form
					form={formComment}
					layout="vertical"
					onFinish={onFinishComment}
					style={{ marginTop: "20px" }}
				>
					<Row gutter={16}>
						<Col span={24}>
							<Form.Item label="Comments" name="comments">
								<Input.TextArea size="large" />
							</Form.Item>
						</Col>
						<Col span={24}>
							<Button
								type="primary"
								htmlType="submit"
								loading={loadingButtonComment}
								size="large"
								style={{ width: "100%" }}
								icon={<SaveFilled twoToneColor="white" />}
							>
								Save
							</Button>
						</Col>
					</Row>
				</Form>
			</Modal>
		);
	};

	return (
		<Layout title="Daily Seller Dashboard" description="Dashboard">
			<Flex gap={"middle"} vertical>
				<RenderSearch />
				{loading ? <CustomSpinner /> : <RenderJobTable />}
				{contextHolder}
				<RenderModalInvoice />
				<RenderModalOpenInvoices />
				<RenderModalSend />
				<RenderModalJobAddress />
				{addLoadModal}
				{logisticsCommentModal}
				<RenderCheckInModal />
				<RenderInvoiceModal />
				<RenderPouringCommentModal />
				<RenderCommentModal />
			</Flex>
		</Layout>
	);
};

export default DailySellerDashboard;
